var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7139 17.3637L39.5993 0.060791H36.0718L23.1471 15.0851L12.8239 0.060791H0.916718L16.527 22.78L0.916718 40.9255H4.44416L18.093 25.0586L28.9957 40.9255H40.9029L24.7123 17.3637H24.7139ZM19.882 22.9802L18.3006 20.7179L5.71505 2.71618H11.1337L21.2902 17.2436L22.8717 19.5059L36.0735 38.3903H30.6548L19.882 22.9802Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany5);
export default __webpack_public_path__ + "static/media/company-5.0bad9ea60a5eb5a848648e0ed35cfec4.svg";
export { ForwardRef as ReactComponent };